import { PromptDataItem } from 'Services/Query/Sales-Enablement/Types';
import { create } from 'zustand';

interface StoreStates {
  salesKit: PromptDataItem;
  salesKitError?: string;
  refetchSalesKit?: boolean;
  salesKitLoading?: boolean;
}

interface Store extends StoreStates {
  setSalesKit: (salesKit: PromptDataItem) => void;
  setSalesKitError?: (error: string) => void;
  setSalesKitLoading?: (loading: boolean) => void;
  setRefetchSalesKit?: (refetch: boolean) => void;
  resetSalesKitStore?: () => void;
}

const initialState: StoreStates = {
  salesKit: {
    _id: '',
    promptId: '',
    productId: '',
    disabled: false,
    data: [],
    prompt: {}
  }
};

export const useSalesKitStore = create<Store>(set => ({
  ...initialState,
  setSalesKit: (salesKit: PromptDataItem) => set({ salesKit }),
  setSalesKitError: (error: string) => set({ salesKitError: error }),
  setRefetchSalesKit: (refetch: boolean) => set({ refetchSalesKit: refetch }),
  setSalesKitLoading: (loading: boolean) => set({ salesKitLoading: loading }),
  resetSalesKitStore: () => set(initialState)
}));
